module.exports = __webpack_public_path__ + "img/192.fixed_soap_dispenser.5ec0a857.svg";